import { Type } from 'class-transformer';
import { IsArray, IsIn, IsOptional, IsString, ValidateNested } from 'class-validator';
import { FIELD_VALUE_SOURCES, type FieldValueSource } from '../../label/field-value-source';
import { LABEL_SUGGESTION_FIELDS, type LabelSuggestionField } from './label-suggestion-field.enum';

/**
 * Transient by design (plan.md decision 5): the API returns this shape, the
 * form shows it, and only an explicit accept persists it with its own
 * `FieldValueSource`. Nothing here reaches the database on its own.
 * `value` is intentionally undecorated: its runtime type depends on `field`
 * (a number for WEIGHT_G/DENSITY_G_PER_ML, a string for LEGAL_NAME, an enum
 * member for STORAGE_CONDITION, a substance id for ALLERGEN_SUBSTANCE).
 */
export class LabelSuggestionDto {
  @IsIn(LABEL_SUGGESTION_FIELDS)
  field!: LabelSuggestionField;

  value!: string | number | null;

  @IsIn(FIELD_VALUE_SOURCES)
  source!: FieldValueSource;

  @IsOptional()
  @IsString()
  explanation?: string;
}

export class LabelSuggestionsResponseDto {
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => LabelSuggestionDto)
  suggestions!: LabelSuggestionDto[];

  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  warnings?: string[];
}
